import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { getStepById } from '../utils/onboardingSteps.config';
import StatusChip from './ui/StatusChip';
import useOnboardingSx from '../hooks/useOnboardingSx';

export default function StepPanel({ stepId, stepStatus, children }) {
  const sx = useOnboardingSx();
  const config = getStepById(stepId);
  if (!config) return null;

  const badgeVariant =
    stepStatus === 'completed'
      ? 'completed'
      : stepStatus === 'skipped'
        ? 'skipped'
        : stepStatus === 'in_progress'
          ? 'draft'
          : config.required
            ? 'required'
            : 'optional';

  return (
    <Paper elevation={0} sx={sx.stepPanel}>
      <Box sx={sx.stepPanelHeader}>
        <Typography variant="h6" component="h2" sx={sx.stepPanelTitle}>
          Step {config.id}: {config.title}
        </Typography>
        <StatusChip variant={badgeVariant} />
      </Box>
      {children}
      <Box sx={sx.stepPanelHelp}>
        <Typography variant="caption" sx={sx.stepPanelHelpLabel}>
          What happens here
        </Typography>
        <Typography variant="body2" sx={sx.stepPanelHelpText}>
          {config.whatHappensHere}
        </Typography>
      </Box>
    </Paper>
  );
}
